import { hot } from 'react-hot-loader/root';
import PropTypes from 'prop-types';
import React from 'react';

import PageWrapper from '../design-system/PageWrapper';
import PageSection from '../design-system/PageSection';
import Container from '../design-system/Containers';
import Paragraph from '../design-system/Paragraph';
import { HeadingArticle } from '../design-system/Headings';
import {
  Form, Field, Submit,
} from '../design-system/Forms';
import { Divider } from '../design-system/Dividers';
import { LinkButton } from '../design-system/Buttons';

import phrasesType from '../proptypes/phrases';
import formType from '../proptypes/forms';
import RadarHeroPageSection from '../design-system/RadarHeroPageSection';

const SignInPage = ({
  signInForm,
  phrases,
  signUpPath,
  magicLinkPath,
  resetPasswordPath,
}) => (
  <PageWrapper bgDark>
    <RadarHeroPageSection container={false}>
      <Container small>
        <HeadingArticle el="h1">{phrases.title}</HeadingArticle>
      </Container>
    </RadarHeroPageSection>
    <PageSection container={false}>
      <Container small>
        <Form {...signInForm} inline>
          <Field label={phrases.email} name="email" type="email" required />
          <Field
            label={phrases.password}
            name="password"
            type="password"
            hint={<a href={resetPasswordPath}>{phrases.forgottenYourPassword}</a>}
            required
          />
          <Submit>{phrases.signIn}</Submit>
        </Form>
        <Paragraph center>{phrases.or}</Paragraph>
        <Paragraph center><a href={magicLinkPath}>{phrases.requestMagicLink}</a></Paragraph>
        <Divider myLg />
        <Paragraph center>{phrases.dontHaveAnAccount}</Paragraph>
        <LinkButton w100 secondary href={signUpPath}>{phrases.signUp}</LinkButton>
      </Container>
    </PageSection>
  </PageWrapper>
);

SignInPage.propTypes = {
  phrases: phrasesType.isRequired,
  signInForm: formType.isRequired,
  signUpPath: PropTypes.string.isRequired,
  magicLinkPath: PropTypes.string.isRequired,
  resetPasswordPath: PropTypes.string.isRequired,
  headerImage: PropTypes.string,
};

SignInPage.defaultProps = {
  headerImage: undefined,
};

export default hot(SignInPage);
